import { Container } from "../../ui/Container";
import { Section } from "../../ui/Section";
import { Button } from "../../ui/Button";
import { CardBody } from "../../ui/Card";
import { Modal, ModalHeader } from "../../ui/Modal";
import React, { useState, useEffect } from "react";
import { fetchData, getRole, getUserDetails } from "../../helpers";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Alert } from "../../ui/Alert";

function ProdukteZuordnung() {
  const [mountedP, setMountedP] = useState(false);
  const [mountedProd, setMountedProd] = useState(false);
  const [mountedPP, setMountedPP] = useState(false);
  const [roleData, setRole] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [stateProjectProductProjectID, setStateProjectProductProjectID] =
    useState("1");
  const [stateProjectProductProductID, setStateProjectProductProductID] =
    useState("1");
  const [stateProjectProductStatus, setStateProjectProductStatus] =
    useState("inactive");
  const [productsData, setProductsData] = useState([]);
  const [projectsData, setProjectsData] = useState([]);
  const [projectProductsData, setProjectProductsData] = useState([]);
  const [errorState, setErrorState] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const onProjectMenuOpen = () => setIsProjectMenuOpen(true);
  const onProjectMenuClose = () => setIsProjectMenuOpen(false);
  const [isMenuProjectOpen, setIsProjectMenuOpen] = useState(false);
  const onProductMenuOpen = () => setIsProductMenuOpen(true);
  const onProductMenuClose = () => setIsProductMenuOpen(false);
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);

  useEffect(() => {
    try {
      getRole().then((result) => setRole(result));
      getProducts();
      getProjects();
      getProjectProducts();
    } catch {
      setErrorState(true);
    }
  }, []);

  async function getProducts() {
    var pData = [];
    if (getUserDetails()) {
      await fetchData(process.env.REACT_APP_API_URL + "/products", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function (data) {
          for (var ii = 0; ii < data.length; ii++) {
            pData.push(data[ii]);
          }
          setProductsData(pData);
          setMountedProd(true);
        })
        .catch((error) => {
          console.log("req failed", error);
        });
    }
  }
  async function getProjects() {
    if (getUserDetails()) {
      await fetchData(process.env.REACT_APP_API_URL + "/projects", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function (data) {
          setProjectsData(data.data);
          setMountedP(true);
        })
        .catch((error) => {
          console.log("req failed", error);
        });
    }
  }

  async function getProjectProducts() {
    var ppData = [];
    if (getUserDetails()) {
      await fetchData(process.env.REACT_APP_API_URL + "/projectproducts", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function (data) {
          for (var ii = 0; ii < data.data.length; ii++) {
            ppData.push(data.data[ii]);
          }
          setProjectProductsData(ppData);
          setMountedPP(true);
        })
        .catch((error) => {
          console.log("req failed", error);
        });
    }
  }

  //post ProjectProduct function
  function postProjectProduct(event) {
    event.preventDefault();

    var projectProductObj = {};
    projectProductObj.project_id = stateProjectProductProjectID;
    projectProductObj.product_id = stateProjectProductProductID;
    projectProductObj.status = stateProjectProductStatus;

    fetchData(process.env.REACT_APP_API_URL + "/projectproducts", {
      method: "POST",
      body: JSON.stringify(projectProductObj),
    })
      .then((response) => response.json())
      .then((response) => getProjectProducts())
      .catch((error) => {
        alert(error);
      });
  }

  //handle dropdown change
  function handleSelectChangePOSTproject(event) {
    setStateProjectProductProjectID(event.value);
  }

  //handle dropdown change
  function handleSelectChangePOSTproduct(event) {
    setStateProjectProductProductID(event.value);
  }

  //handle dropdown change
  function handleSelectChangePOSTstatus(event) {
    setStateProjectProductStatus(event.target.value);
  }

  //logic to display projectProducts

  const projectDropdownData = projectsData.map((project, id) => {
    return {
      label: project.name,
      value: project.id,
    };
  });

  const productsDropdownData = productsData.map((product, id) => {
    return {
      label: product.title,
      value: product.id,
    };
  });

  function listenerStateProjectProductStatus(status) {
    return status;
  }

  function handleSelectChangeProjectProductStatus(event) {
    var strId = event.target.id;
    var value = event.target.value;
    var id = strId.slice(strId.lastIndexOf("-") + 1);

    onSave(id, value);
  }

  //update useroffer
  function onSave(id, value) {
    var projectProductObj = {};
    projectProductObj.status = value;

    fetchData(process.env.REACT_APP_API_URL + "/projectproducts/" + id, {
      method: "PUT",
      body: JSON.stringify(projectProductObj),
    })
      .then((response) => response.json())
      .then((response) => getProjectProducts());
  }

  function onDelete(id) {
    fetchData(process.env.REACT_APP_API_URL + "/projectproducts/" + id, {
      method: "DELETE",
    })
      .then((response) => response.json())
      .then((response) => getProjectProducts());
  }

  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);

    const sortedItems = React.useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
      let direction = "ascending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };

  const ProjectProductsTable = (props) => {
    const { items, requestSort, sortConfig } = useSortableData(
      props.projectProducts
    );
    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };
    return (
      <table className="min-w-full divide-y divide-gray-400 px-6 py-3">
        <thead className="">
          <tr>
            <th
              scope="col"
              className="w-3/12 px-6 py-4 text-left text-xl font-medium text-gray-500"
            >
              <button
                type="button"
                onClick={() => requestSort("project_id")}
                className={getClassNamesFor("project_id")}
              >
                Projekt
              </button>
            </th>
            <th
              scope="col"
              className="w-5/12 px-6 py-4 text-left text-xl font-medium text-gray-500"
            >
              <button
                type="button"
                onClick={() => requestSort("product_id")}
                className={getClassNamesFor("product_id")}
              >
                Produkt
              </button>
            </th>
            <th
              scope="col"
              className="w-3/12 px-6 py-4 text-left text-xl font-medium text-gray-500"
            >
              <button
                type="button"
                onClick={() => requestSort("status")}
                className={getClassNamesFor("status")}
              >
                Status
              </button>
            </th>
            <th className="w-1/12 px-6 py-4 text-left text-xl font-medium text-gray-500"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {items
            .filter((itemData) => {
              if (searchTerm == "") {
                return itemData;
              } else if (
                projectsData
                  .filter((p) => p.id === itemData.project_id)
                  .map((p) => p.name)
                  .toString()
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) ||
                productsData
                  .filter((p) => p.id === itemData.product_id)
                  .map((p) => p.title)
                  .toString()
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              ) {
                return itemData;
              }
            })
            .map((projectproduct, id) => (
              <tr key={"projectproduct-" + id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  {projectsData
                    .filter((p) => p.id === projectproduct.project_id)
                    .map((p) => p.name)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {productsData
                    .filter((p) => p.id === projectproduct.product_id)
                    .map((p) => p.title)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {
                    <select
                      className="block appearance-none w-full  border-none bg-gray-100 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-400"
                      id={"projectproduct-status-" + projectproduct.id}
                      onSelect={listenerStateProjectProductStatus}
                      onChange={handleSelectChangeProjectProductStatus}
                    >
                      {projectproduct.status === "offered" ? (
                        <>
                          <option value="offered">Angeboten</option>
                          <option value="booked">Gebucht</option>
                          <option value="inactive">Inaktiv</option>
                        </>
                      ) : (
                        <></>
                      )}
                      {projectproduct.status === "booked" ? (
                        <>
                          <option value="booked">Gebucht</option>
                          <option value="offered">Angeboten</option>
                          <option value="inactive">Inaktiv</option>
                        </>
                      ) : (
                        <></>
                      )}
                      {projectproduct.status === "inactive" ? (
                        <>
                          <option value="inactive">Inaktiv</option>
                          <option value="offered">Angeboten</option>
                          <option value="booked">Gebucht</option>
                        </>
                      ) : (
                        <></>
                      )}
                    </select>
                  }
                </td>
                <td className="px-6 py-4 whitespace-nowrap float-right w-full">
                  <Button
                    onClick={() => onDelete(projectproduct.id)}
                    className=""
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className="" />
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      {errorState ? (
        <Section>
          <Container>
            <Alert type="secondary">
              Serverfehler! Etwas ist schief gelaufen. Informieren Sie einen
              Entwickler.
            </Alert>
          </Container>
        </Section>
      ) : (
        <div>
          {roleData === "admin" ? (
            <div className="">
              {mountedProd && mountedP && mountedPP ? (
                <Section>
                  <Container>
                    <Modal open={isOpen} className="">
                      <ModalHeader
                        heading="Neue Zuordnung"
                        onClose={() => setIsOpen(false)}
                      />

                      <CardBody className="">
                        <form>
                          <div className="grid gap-4 w-96 mb-4">
                            <div>
                              <label
                                className="block tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="project"
                              >
                                Projekt
                              </label>
                              <Select
                                onMenuOpen={onProjectMenuOpen}
                                onMenuClose={onProjectMenuClose}
                                options={projectDropdownData}
                                onChange={handleSelectChangePOSTproject}
                                placeholder="Projekt..."
                              />
                            </div>
                            <div>
                              <label
                                className="tracking-wide text-gray-700 text-xs font-bold"
                                htmlFor="product"
                              >
                                Produkt
                              </label>
                              <Select
                                onMenuOpen={onProductMenuOpen}
                                onMenuClose={onProductMenuClose}
                                options={productsDropdownData}
                                onChange={handleSelectChangePOSTproduct}
                                placeholder="Produkt..."
                              />
                            </div>
                            <div>
                              <label
                                className="tracking-wide text-gray-700 text-xs font-bold"
                                htmlFor="status"
                              >
                                Status
                              </label>
                              <select
                                className="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-3 leading-tight"
                                name="status"
                                defaultValue={stateProjectProductStatus}
                                selected={stateProjectProductStatus}
                                onChange={handleSelectChangePOSTstatus}
                              >
                                <option value="offered">Angeboten</option>
                                <option value="booked">Gebucht</option>
                                <option value="inactive">Inaktiv</option>
                              </select>
                            </div>
                          </div>
                          <Button
                            variant="primary"
                            type=""
                            className=""
                            onClick={postProjectProduct}
                          >
                            Zuordnung anlegen
                          </Button>
                        </form>
                      </CardBody>
                    </Modal>
                    <div className="flex mb-2">
                      {" "}
                      <div className="w-10/12">
                        <h1 className="text-4xl font-bold mb-8">
                          Produkte - Zuordnung&nbsp;
                        </h1>
                      </div>
                      <div className="w-2/12">
                        <Button onClick={() => setIsOpen(true)} className="">
                          <FontAwesomeIcon icon={faPlus} className="" />
                        </Button>
                      </div>
                    </div>
                    <div className="flex mb-8 flex-row-reverse">
                      <div className="w-2/12 ">
                        <input
                          type="text"
                          className="text-hpl bg-hpl_bg hover:bg-gray-300 hover:text-gray-800 border-none rounded w-full"
                          placeholder="Suche..."
                          onChange={(event) => {
                            setSearchTerm(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-full">
                      <ProjectProductsTable
                        projectProducts={projectProductsData}
                      />
                    </div>
                  </Container>
                </Section>
              ) : (
                <div>
                  <Container>Loading...</Container>
                </div>
              )}
            </div>
          ) : (
            <Section>
              <Container>
                <Alert type="secondary">
                  Auf diese Ansicht haben Sie keinen Zugriff!
                </Alert>
              </Container>
            </Section>
          )}
        </div>
      )}
    </div>
  );
}

export default ProdukteZuordnung;
